import React from "react";
import ReactDOM from "react-dom";
import {HashRouter, Route, Switch } from "react-router-dom";
import { PrivateRoute } from './helpers/PrivateRoute';
import indexRoutes from "./routes/index.jsx";
import { disableReactDevTools } from '@fvilers/disable-react-devtools';



import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/sass/pay-dashboard.css?v=1.1.1";
import "./assets/css/demo.css";
import "./assets/css/pe-icon-7-stroke.css";
if (process.env.NODE_ENV === 'production') {
  disableReactDevTools();
}
ReactDOM.render(
  <HashRouter>
    <Switch> 
      
      {indexRoutes.map((prop, key) => {
        if(prop.public){
      
        return <Route path={prop.path} component={prop.component} key={key} />;}{
      
          return <PrivateRoute path={prop.path} component={prop.component} key={key} />;
        }
      }
        )
      })
    
    </Switch>
    </HashRouter>,
  document.getElementById("root")
);
